import { Col, Row } from 'antd';
import { get } from 'lodash';
import React from 'react';

import { renderBooleanCheckmarks } from '../../../utils/tables';
import Button from '../../Button';
import CustomTable from '../../Table';
import Tag from '../../Tag';

const ReportsTable = props => {
  const { t, dataSource, onEditReportClick, onDeleteReportClick, ...rest } = props;

  const COLUMNS = [
    {
      key: 'name',
      title: t('name'),
      dataIndex: 'name',
    },
    {
      key: 'sourceType',
      title: t('source'),
      dataIndex: 'sourceType',
    },
    {
      key: 'tags',
      title: t('tags'),
      dataIndex: 'tags',
      render: tags => {
        console.log('tags', tags);

        if (!tags || !Array.isArray(tags)) {
          return null;
        }

        return (
          <>
            {tags.map((tag, index) => (
              <Tag variant="primary" key={index} style={{ marginBottom: 8 }}>
                {tag.name}
              </Tag>
            ))}
          </>
        );
      },
    },
    {
      align: 'center',
      key: 'visibleGlobally',
      title: t('enabled'),
      ...renderBooleanCheckmarks('visibleGlobally'),
    },
    {
      align: 'center',
      key: 'visibleOnReportsPage',
      title: t('visibleOnReportsPage'),
      ...renderBooleanCheckmarks('visibleOnReportsPage'),
    },
    {
      align: 'center',
      key: 'sendGroupIdAsString',
      title: t('sendGroupIdAsString'),
      ...renderBooleanCheckmarks(['settings', 'sendGroupIdAsString']),
    },
    {
      align: 'center',
      key: 'metabaseId',
      title: t('metabaseId'),
      dataIndex: ['settings', 'dashboardId'],
    },
    {
      key: 'requiredFilterKeys',
      title: t('requiredFilterKeys'),
      render: data => {
        const { settings } = data;
        const filters = [];
        Object.values(settings).forEach((val, i) => {
          if (!!get(val, 'required') && !!get(val, 'keyName')) {
            filters.push(
              t('metabaseKeyNamePair', {
                name: Object.keys(settings)[i],
                keyname: get(val, 'keyName', null),
              }),
            );
          }
        });

        return (
          <ul>
            {filters.map(filter => (
              <li key={filter}>{filter}</li>
            ))}
          </ul>
        );
      },
    },
    {
      key: 'optionalFilterKeys',
      title: t('optionalFilterKeys'),
      render: data => {
        const { settings } = data;
        const filters = [];
        Object.values(settings).forEach((val, i) => {
          if (!get(val, 'required') && !!get(val, 'keyName')) {
            filters.push(
              t('metabaseKeyNamePair', {
                name: Object.keys(settings)[i],
                keyname: get(val, 'keyName', null),
              }),
            );
          }
        });

        return (
          <ul>
            {filters.map(filter => (
              <li key={filter}>{filter}</li>
            ))}
          </ul>
        );
      },
    },
    {
      key: 'edit',
      title: t('actions'),
      render: (actions, data) => (
        <Row gutter={[8, 8]}>
          <Col flex={1}>
            <Button block size="xs" onClick={() => onEditReportClick(data)}>
              {t('Edit')}
            </Button>
          </Col>
          <Col flex={1}>
            <Button block type="secondary" size="xs" onClick={() => onDeleteReportClick(data._id)}>
              {t('Delete')}
            </Button>
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <CustomTable
      {...rest}
      rowKey={data => data._id}
      scroll={{ x: 900 }}
      columns={COLUMNS}
      dataSource={dataSource}
      showSearchInput={false}
    />
  );
};

export default ReportsTable;
